<script setup>
import { useStateStore } from '@/stores/state.store';
import Tr from '@/i18n/translation';
import ProductRoutes from '@/router/routeNames';

const stateStore = useStateStore();

const props = defineProps({
  reversed: {
    type: Boolean,
    default: false,
  },
});

const mainColor = props.reversed
  ? stateStore.getColors.backgroundColor
  : stateStore.getColors.mainColor;
const backgroundColor = props.reversed
  ? stateStore.getColors.mainColor
  : stateStore.getColors.backgroundColor;
</script>

<template>
  <div class="gks-content">
    <router-link
      :to="Tr.i18nRoute({ name: ProductRoutes.gks })"
      class="core-default-form-button gks-button"
    >
      {{ $t('appCore.apps.components.gks.findTable') }}
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styleConstans';

.gks-content {
  display: flex;
  flex-flow: row wrap;
  gap: 15px 25px;
  align-items: center;
  justify-content: space-evenly;
  margin: 20px auto;
}

.gks-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
  min-width: 250px;
  border: 2px solid v-bind(backgroundColor);
  background-color: v-bind(mainColor);
  color: v-bind(backgroundColor);
  font-family: Lato, sans-serif;
  font-size: 1.75em;
  letter-spacing: 0.7px;

  &:hover {
    background-color: v-bind(backgroundColor);
    color: v-bind(mainColor);
    border: 2px solid v-bind(mainColor);
    cursor: pointer;
  }

  @media screen and (max-width: $media-phone) {
    font-size: 1.25em;
  }
}
</style>
